import { Message } from '@/utils/Message'

// 获取当前的环境
// const CURRENT_ENV = process.env.NODE_ENV

const excludeLoggers = []
// 优先级高
const includeLoggers = []
const LOG_TYPES = {
  LOG: 'log',
  WARN: 'warn',
  ERROR: 'error',
  DEBUG: 'debug'
}
// const loggerPrefixCss = 'color:red;font-size:25px;text-shadow:1px 1px 1px #ccc'
/**
 * 为了自定义日志输出，
 * 后期可增加买点功能
 */
export default class Logger {
  constructor(context) {
    this._context = context

    // console.log(this._context)
    // 路径+ vue文件名 + 引用链
    this._initLoggerPrefix(context)
    this._options = {}
    this.recoverOptions()
    this._allowInput = true
  }

  filterRule(func) {
    this._filterRule = func
  }

  appendPrefix(val) {
    this._loggerPrefix += val
  }
  log() {
    this._commonLog([...arguments], LOG_TYPES.LOG)
  }

  warn() {
    this._commonLog([...arguments], LOG_TYPES.WARN)
  }
  debug() {
    this._commonLog([...arguments], LOG_TYPES.DEBUG)
  }

  error() {
    this._commonLog([...arguments], LOG_TYPES.ERROR)
  }

  _initLoggerPrefix(context) {
    if (context && typeof context === 'object' && context._isVue && context.$options) {
      this._loggerPrefix = `context-name:${context.$options.name}`
      this._contextName = context.$options.name
    } else if (context instanceof Object) {
      // todo class
      const classPaths = []
      let tempContext = Reflect.getPrototypeOf(context)
      this._contextName = tempContext.constructor.name
      while (tempContext != null) {
        classPaths.unshift(tempContext.constructor.name)
        tempContext = Reflect.getPrototypeOf(tempContext)
      }
      this._loggerPrefix = `class-name:${classPaths.join('.')}`
    } else {
      this._contextName = context.name || context || '未声明文件名称'
      this._loggerPrefix = `context-name:${this._contextName}`
    }
  }
  _convertMessageType(logType) {
    let messageType = 'warn'
    switch (logType) {
      case 'error':
        messageType = 'error'
    }
    return messageType
  }
  _pre() {
    // --...
  }
  _post(args, logType) {
    const message = args.join('==>')
    if (this._options.allowTip) {
      const msgType = this._convertMessageType(logType)
      // 不要使用组件，否则死循环
      Message({ message, type: msgType })
    }
    if (this._options.allowReport) {
      // todo 上报后台数据 异步上报
    }
    if (this._options.allowThrow) {
      throw new Error(message)
    }
  }

  _commonLog(args, type = LOG_TYPES.LOG) {
    args.unshift(this._loggerPrefix)
    const message = args.join('==>')
    // 根据全局配置，判断是否输出日志
    if (excludeLoggers.includes(this._contextName) && !includeLoggers.includes(this._contextName) && !this._options.allowThrow) {
      return
    }
    if (this._filterRule && this._filterRule(message)) {
      return
    }
    try {
      this._pre()
      // console[type](`c%${this._loggerPrefix}`, loggerPrefixCss, ...args)
      console[type](...args)
      this._post(args, type)
    } catch (e) {
      throw new Error(e)
    } finally {
      this.recoverOptions()
    }
  }

  recoverOptions() {
    this._options.allowTip = false
    this._options.allowThrow = false
    this._options.allowReport = false
  }
  tip(allowed) {
    this._options.allowTip = allowed
    return this
  }
  throw(allowed) {
    this._options.allowThrow = allowed
    return this
  }
  report(allowed) {
    this._options.allowReport = allowed
    return this
  }
  destroy() {
    this._context = null

    // console.log(this._context)
    // 路径+ vue文件名 + 引用链
    this._options = null
    this._allowInput = null
  }
}
